import { useState } from "react";

import { useAuthenticationManager } from "scenes/Authentication/hooks/useAuthenticationManager";

export function useResetPasswordForm({ email }, onDone = () => {}) {
  const { forgotPasswordSubmit, forgotPassword, isProcessing } =
    useAuthenticationManager();
  const [error, setError] = useState();

  const run = async (action, defaultError) => {
    setError("");
    try {
      await action();
    } catch (err) {
      setError(err?.message || defaultError);
    }
  };

  return {
    loading: isProcessing,
    error: error,
    reset: async ({ code, password }) => {
      await run(async () => {
        await forgotPasswordSubmit(email, code, password);
        onDone();
      }, "Failed to reset password.");
    },
    resendCode: async () => {
      await run(async () => {
        await forgotPassword(email);
      }, "Failed to resend verification code.");
    },
  };
}

export default useResetPasswordForm;
